import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=f18f814e&scoped=true&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"
import style0 from "./empty.vue?vue&type=style&index=0&id=f18f814e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f814e",
  null
  
)

export default component.exports